import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getCategories(params) {
  const response = await axiosClient.get(`/Categories${toQueryString(params)}`);
  return response.data;
}

// With storeId, the response also includes that store's own custom option values.
export async function getCategoryAttributes(id, storeId) {
  const response = await axiosClient.get(`/Categories/${id}/attributes`, {
    params: storeId ? { storeId } : undefined,
  });
  return response.data;
}

export async function setCategoryAttributes(id, payload) {
  const response = await axiosClient.put(`/Categories/${id}/attributes`, payload);
  return response.data;
}
